// flow weak

import React, {
    Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  
  
  class CreateVenue extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        venue_details: {
            venue_name:'',
            address:'',
            contact_number: '',
            landmark:'',
            city:'',
            location:'',
            start_time:'05:00',
            end_time:'23:00',
            is_active: false,
            is_test_venue: false,
            is_thirty_min: false,
            is_court_booking: false,
            is_equipment_rental: false,
            // is_playo_enabled: false,
            is_franchise: false,
            playo_api_token:'',
            playo_user_name:'',
            playo_user_password:'',
            non_operational_start_time:'00:00',
            non_operational_end_time:'05:00',
            image1: '',
            image2:'',
            image3:'',
            image4:'',
            latitude:'',
            longitude:'',
            direction:''
        }, 
        revenue_share: [],
        amenities: [],
        utilities: [],
        city_arr: [],
        location_arr: [],
        buddies_arr:[],
        game_types: [],
        selected_games: [],
        selected_amenities: [],
        selected_utilities: [],
        selected_buddies:[],
        selected_city:'',
        selected_location:'',
        temp_list_game: [],
        temp_list_amenity: [],
        temp_list_utility: [],
        temp_list_buddy:[],
        temp_revenue_list:[],
        search:false,
        customer_search_list: [],
        dialog_open_cust:true,
        amount:0,
        dialog:false,
        venue_id:'',
        temp_images:{
            image1:'',
            image2:'',
            image3:'',
            image4:''
        },
        success:false,
        message:''
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.onStartTimeChange = this.onStartTimeChange.bind(this)
      this.onEndTimeChange = this.onEndTimeChange.bind(this)
      this.handleImages = this.handleImages.bind(this)
      this.onSelect = this.onSelect.bind(this);
      this.onChange = this.onChange.bind(this);
      this.handleCityChange = this.handleCityChange.bind(this);
      this.handleLocationChange = this.handleLocationChange.bind(this);
      this.postImageUpload = this.postImageUpload.bind(this);
      this.handleRevenueShare = this.handleRevenueShare.bind(this);

    }
  
    componentDidMount() {
        this.getDetails();
    }

    handlecustClose = () => {
      this.setState({dialog_open_cust:false});
    };

    handleOpen=()=>{
      this.setState({dialog_open_cust:true})
    }    

    getDetails(){
      const url = `${getLocationOrigin()}/get_venue_list/get_details_for_venue_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            if(data.success){
              console.log('heree..')
               this.setState({city_arr:data.result.location,selected_city:data.result.location[0].city_id,selected_location:data.result.location[0].locations[0].location_id,
                amenities:data.result.amenities,utilities:data.result.utilities,game_types:data.result.game_types,
                location_arr:data.result.location[0].locations,success:data.success,message:data.message, buddies_arr:data.result.buddies},()=>{this.setLocation()});
            }
            else{
                console.log('there..')
                console.log(data.success)
                this.setState({success:data.success,message:data.message})
            }
           // alert("fix");
       }).catch(error => error);
    }

    postImageUpload(props) {
        console.log('inside postImageUpload')
        const url = `${getLocationOrigin()}/get_venue_list/upload_venue_images/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        var formData = new FormData();
        formData.append('venue_id',this.state.venue_id);
        formData.append('image1',this.state.venue_details.image1);
        formData.append('image2',this.state.venue_details.image2);
        formData.append('image3',this.state.venue_details.image3);
        formData.append('image4',this.state.venue_details.image4);
        options['body'] = formData
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(function(response){                      // first then()
              if(response.success){
                alert(response.message);
                props.history.goBack();
                // window.location.reload()
              }
              else{
                alert(response.message);
              }
              
            })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });

    }


    postUpdateBooking(details,revenue_share,props) {
        console.log(details)
        const url = `${getLocationOrigin()}/get_venue_list/create_venue/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                          'venue_details': details,
                                          'game_types': this.state.selected_games,
                                          'amenities': this.state.selected_amenities,
                                          'utilities': this.state.selected_utilities,
                                          'buddies': this.state.selected_buddies,
                                          'revenue_share':revenue_share
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(response=>{  
            console.log('response',response)
              if(response.success){
                  this.setState({venue_id:response.venue_id},()=>{this.postImageUpload(props)})
              }
              else{
                alert(response.message)
              }
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }

    


    handleChange(event) {
        const name = event.target.name;
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        console.log(name,value)
        var new_value =  Object.assign({}, this.state.venue_details);
        new_value[name] = target.type === 'checkbox' ? target.checked : target.value
        this.setState({venue_details: new_value});
        // this.getAmount(this.state.equipment_details)
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        var rev_share = this.state.revenue_share.filter(share=> this.state.selected_games.includes(parseInt(share.game_id)))
        // var sum = rev_share.reduce(function(total,each){
        //   return total + parseFloat(each.share)
        // },0)
        // var is_zero = rev_share.find(each=>parseInt(each.share) == 0)
        // console.log('is_zero',is_zero)
        // if(this.state.venue_details.is_court_booking == false && sum != 100){
        //   alert('Total revenue share must be 100')
        // }
        // else if(this.state.venue_details.is_court_booking == false && is_zero) {
        //   alert('Share must be greater than 0')
        // }
        // else{
          this.postUpdateBooking(this.state.venue_details,rev_share ,this.props)
        // }
      }

    onStartTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.venue_details);
    new_value['start_time'] = options
    this.setState({venue_details: new_value});
    }

    onEndTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.venue_details);
    new_value['end_time'] = options
    this.setState({venue_details: new_value});
    }

    handleImages(event) {
    console.log('files',event.target.files)
    var image = event.target.files[0]
    var name = event.target.name
    console.log(name,image)
    var new_value =  Object.assign({}, this.state.venue_details);
    var images =  Object.assign({}, this.state.temp_images);
    new_value[name] = image
    images[name] = window.URL.createObjectURL(image)
    this.setState({venue_details:new_value,temp_images:images})
    }

    onSelect(optionsList, selectedItem) {
        var name = optionsList.name ;
        if(name=== 'game'){
            this.state.temp_list_game.push(optionsList.pk)
            this.setState({ selected_games: this.state.temp_list_game,selected_name: name });
        }
        else if(name === 'amenity'){
            this.state.temp_list_amenity.push(optionsList.id)
            this.setState({ selected_amenities:this.state.temp_list_amenity , selected_name: name});
        }
        else if(name === 'utility'){
            this.state.temp_list_utility.push(optionsList.id)
            this.setState({selected_utilities: this.state.temp_list_utility, selected_name: name});
        }
        else if(name==='buddy'){
            this.state.temp_list_buddy.push(optionsList.id)
            this.setState({selected_buddies: this.state.temp_list_buddy, selected_name: name});
        }
    }

    onChange(dataItem,event){
      var name = event.dataItem.name
      if(name === 'game'){
        this.setState({selected_games:dataItem.map(x => x.pk),selected_name: name });
      }
      else if(name === 'amenity'){
        this.setState({selected_amenities:dataItem.map(x => x.id), selected_name: name});
      }
      else if(name === 'utility' ){
        this.setState({selected_utilities: dataItem.map(x => x.id), selected_name: name});
      }
      else if(name === 'buddy' ){
        this.setState({selected_buddies: dataItem.map(x => x.id), selected_name: name});
      }
    }

    setLocation(){
        var new_value =  Object.assign({}, this.state.venue_details);
        new_value['city'] = this.state.selected_city
        new_value['location'] = this.state.selected_location
        this.setState({venue_details: new_value});
    }

    handleCityChange(event){
        console.log('city',event.target.value)
        const city = this.state.city_arr
        const value = event.target.value
        const name = event.target.name
        var new_value =  Object.assign({}, this.state.venue_details);
        new_value[name] = value
        const loc = city.find(temp=> temp.city_id == value)
        new_value['location'] = loc.locations[0].location_id
        this.setState({venue_details: new_value,location_arr:loc.locations}); 
    }

    handleLocationChange(event) {
        const value = event.target.value
        const name = event.target.name
        var new_value =  Object.assign({}, this.state.venue_details);
        new_value[name] = value;
        this.setState({venue_details: new_value});
    }

    handleRevenueShare(event) {
      const value = event.target.value
      const name = event.target.name
      var new_value =  {}
      new_value['game_id'] = name
      new_value['share'] = value
      var temp_data = this.state.temp_revenue_list
      var check = true
      for (var i = temp_data.length - 1; i >= 0; i--) {
        if(temp_data[i].game_id == name){
          temp_data[i].share = value
          check = false
        }
      }

      if(check){
        temp_data.push(new_value)
      }
      this.setState({revenue_share:temp_data,temp_revenue_list:temp_data})
    }
        


  
    render() {
      console.log('amount')
      console.log(this.state.venue_details);
      console.log(this.state.selected_buddies)
      console.log(this.state.success)
      console.log('revenue_share',this.state.revenue_share)
      var available_game_types = []
      if(this.state.selected_games.length > 0){
      available_game_types = this.state.game_types.filter(game_type=> this.state.selected_games.includes(game_type.pk))
      console.log('available_game_types',available_game_types)
     }
       
      return(
        <div style={styles.container}> 

          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12 label_blue_1">
              <h3 style={{textAlign:'center'}}> Create Venue</h3>
            </div>

            { this.state.success ?
                <form  className="validated-form form-horizontal">

                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Venue Name
                    </div>
                    <input style={styles.input} name="venue_name" 
                    onChange={this.handleChange} />
                  </div>

                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Address
                    </div>
                    <textarea style={styles.textbox} name="address"
                    onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Landmark
                    </div>
                    <textarea style={styles.textbox} name="landmark"
                    onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    City
                  </div>
                 <select name="city" className="col-md-6" style={styles.item_body} value={this.state.value}
                   onChange={this.handleCityChange}>
                    {
                       this.state.city_arr.map((location,index)=>(
                         <option key={location.city_id} value={location.city_id}>{location.city}</option>
                        ))
                     }
                 </select>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Location
                  </div>
                 <select name="location" className="col-md-6" style={styles.item_body} value={this.state.value}
                   onChange={this.handleLocationChange}>
                    {
                       this.state.location_arr.map((location,index)=>(
                         <option key={location.location_id} value={location.location_id}>{location.name}</option>
                        ))
                     }
                 </select>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Latitude
                    </div>
                    <input style={styles.input}  name="latitude" 
                    onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Longitude
                    </div>
                    <input style={styles.input}  name="longitude" 
                    onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Direction Link
                    </div>
                    <input style={styles.input}  name="direction" 
                    onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Contact Number
                  </div>
                  <input type="number" style={styles.input} name="contact_number1" maxLength={10}
                  onChange={this.handleChange}/>
                </div>


                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Description
                  </div>
                  <textarea style={styles.textbox} name="description" rows="5"
                  onChange={this.handleChange}/>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>Start Time </span>
                        <div style={{width:'50%'}}>
                            <TimePicker className="col-md-3" style={{width:'50%'}} theme="classic" time={this.state.venue_details.start_time} name='start_time' onTimeChange={this.onStartTimeChange} />
                        </div>
                    </div>
                    <div style={styles.item_header} className="col-md-6">
                        <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>End Time </span>
                        <div style={{width:'50%'}}>
                            <TimePicker className="col-md-3" style={{width:'50%'}} theme="classic" time={this.state.venue_details.end_time} name='end_time' onTimeChange={this.onEndTimeChange} />
                        </div>
                    </div>
                </div>

                <div style={styles.items,{display:'flex',flexDirection:'column'}} className="col-md-12">
                    <div style={styles.items,{padding:'0%',paddingTop:'1%'}}>
                        <div style={styles.item_header} className="col-md-6">Is the venue active ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_active' onChange={this.handleChange}/></div>
                    </div>
                    <div style={styles.items,{padding:'0%',paddingTop:'1%'}}>
                        <div style={styles.item_header} className="col-md-6">Is thirty minutes allowed ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_thirty_min' onChange={this.handleChange}/></div>
                    </div>
                    <div style={styles.items,{padding:'0%',paddingTop:'1%'}}>
                        <div style={styles.item_header} className="col-md-6">Is equipment rental allowed ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_equipment_rental' onChange={this.handleChange}/></div>
                    </div>
                   
                    <div style={styles.items,{padding:'0%',paddingTop:'1%'}}>
                        <div style={styles.item_header} className="col-md-6">Is franchise venue ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_franchise' onChange={this.handleChange}/></div>
                    </div>
                    <div style={styles.items,{padding:'0%',paddingTop:'1%'}}>
                        <div style={styles.item_header} className="col-md-6">Is test venue ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_test_venue' onChange={this.handleChange}/></div>
                    </div>
                    <div style={styles.items,{padding:'0%',paddingTop:'1%'}}>
                        <div style={styles.item_header} className="col-md-6">Is court booking allowed ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_court_booking' onChange={this.handleChange}/></div>
                    </div>
                </div>

                { this.state.venue_details.is_court_booking ?
                    <div style={{marginTop:'1%'}}>
                        <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                Playo Api Token
                            </div>
                            <input style={styles.input} name="playo_api_token" 
                            onChange={this.handleChange} />
                        </div>
                        <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                Playo User Name
                            </div>
                            <input style={styles.input} name="playo_user_name" 
                            onChange={this.handleChange} />
                        </div>
                        <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                Playo User Password
                            </div>
                            <input style={styles.input} name="playo_user_password" 
                            onChange={this.handleChange} />
                        </div>
                        <div style={styles.items,{marginTop:'2%'}} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>Non-operational Start Time </span>
                                <div style={{width:'50%'}}>
                                    <TimePicker className="col-md-3" style={{width:'50%'}} theme="classic" time={this.state.venue_details.non_operational_start_time} 
                                    name='non_operational_start_time' onTimeChange={this.onStartTimeChange} />
                                </div>
                            </div>
                            <div style={styles.item_header} className="col-md-6">
                                <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>Non-operational End Time </span>
                                <div style={{width:'50%'}}>
                                    <TimePicker className="col-md-3" style={{width:'50%'}} theme="classic" time={this.state.venue_details.non_operational_end_time} 
                                    name='non_operational_end_time' onTimeChange={this.onEndTimeChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    ''
                }


                <div style={styles.items,{marginTop:'2%'}} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Venue Image
                    </div>
                    <div style={styles.item_header} className="col-md-6">
                        <input onChange={this.handleImages} accept='image/*' name="image1" type='file' id='image' />
                        { this.state.temp_images.image1 ?
                            <img id="image1" src={this.state.temp_images.image1} alt="venue image" width="100" height="100" />
                        :
                        'No Image'
                        }
                    </div>
                </div>

                <div style={styles.items,{marginTop:'2%'}} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Extra Image 1
                    </div>
                    <div style={styles.item_header} className="col-md-6">
                        <input onChange={this.handleImages} accept='image/*' name="image2" type='file' id='image' />
                        { this.state.temp_images.image2 ?
                            <img id="image2" src={this.state.temp_images.image2} alt="extra image 1" width="100" height="100" />
                        :
                        'No Image'
                        }
                    </div>
                </div>

                <div style={styles.items,{marginTop:'2%'}} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Extra Image 2
                    </div>
                    <div style={styles.item_header} className="col-md-6">
                        <input onChange={this.handleImages} accept='image/*' name="image3" type='file' id='image' />
                        { this.state.temp_images.image3 ?
                            <img id="image3" src={this.state.temp_images.image3} alt="extra image 2" width="100" height="100" />
                        :
                        'No Image'
                        }
                    </div>
                </div>

                <div style={styles.items,{marginTop:'2%'}} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Extra Image 3
                    </div>
                    <div style={styles.item_header} className="col-md-6">
                        <input onChange={this.handleImages} accept='image/*' name="image4" type='file' id='image' />
                        { this.state.temp_images.image4 ?
                            <img id="image4" src={this.state.temp_images.image4} alt="extra image 3" width="100" height="100" />
                        :
                        'No Image'
                        }
                    </div>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Buddies
                  </div>
                  <div style={styles.item_body} className="col-md-6">
                      <Multiselect
                        id="3"  
                        placeholder="Click to select"
                        data={this.state.buddies_arr}
                        textField='buddy_name'
                        onSelect={this.onSelect} 
                        onChange={this.onChange}
                        filter='contains' 
                       />
                  </div>      

              </div>


                <div style={styles.items} className="col-md-12">
                    <div style={styles.items} className="col-md-4" style={{flexDirection:'column',marginTop: '8px'}}>
                        <Multiselect
                          id="3"  
                          placeholder="Available Games"
                          data={this.state.game_types}
                          textField='game'
                          onSelect={this.onSelect} 
                          onChange={this.onChange}
                          filter='contains' 
                         />
                    </div>      


                    <div style={styles.items} className="col-md-4" style={{flexDirection: 'column', marginTop: '8px'}}>
                        <Multiselect
                          id="1"
                          placeholder="Amenities"
                          data={this.state.amenities}
                          textField='value'
                          onSelect={this.onSelect} 
                          onChange={this.onChange} 
                          filter='contains'
                         />
                    </div>

                    <div style={styles.items} className="col-md-4" style={{flexDirection: 'column', marginTop: '8px'}}>
                        <Multiselect
                          placeholder="Utilities"
                          data={this.state.utilities}
                          textField='value'
                          onSelect={this.onSelect} 
                          onChange={this.onChange} 
                         /> 
                    </div>
                </div>

                { available_game_types.length > 0 ?
                  <div>
                    <div style={styles.items,{color:'red',fontSize:'1.5em',paddingLeft:'5%'}} className='col-md-12'>
                      Enter Revenue Share Percentage without % Symbol - i.e. 29.5
                    </div>

                    { available_game_types.map((game_type,index)=>
                      <div style={styles.items} className="col-md-12">
                          <div style={styles.item_header} className="col-md-6">
                              {game_type.game}
                          </div>
                          <input type='number' style={styles.input} name={game_type.pk} placeholder='Revenue Share i.e. 30.4 without %'
                          onChange={this.handleRevenueShare} />
                      </div>
                      )
                    }
                  </div>
                  :
                  ''
                }

                <div style={styles.items,{color:'red',fontSize:'1em',paddingLeft:'5%'}} className='col-md-12'>
                    Please make sure all the provided details are correct
                </div>
               
                <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
                  <div style={styles.button_submit} className="col-md-12">
                    <input className="button1" type="submit" value="Create Venue" onClick={this.handleSubmit}/>
                  </div>
                </div>
                  
              </form>
            :
            <div style={styles.message}>{this.state.message}</div>
            }
          </div>
        </div>
      );
    }
  }
  
  export default CreateVenue;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/createVenue/CreateVenue.js